import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment FieldGroupFragment
 * @since 1.0.0
 */
export const FieldGroupFragment = gql `
  fragment FieldGroupFragment on FieldGroup {
    id
    title
    infos
    category

    createdAt
    updatedAt

    fields {
      ...FieldFragment
    }

    translations {
      id
      title
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }
  }
  ${FieldFragment}
  ${LanguageFragment}
`;
